import { RefUnite } from './ref-unite.model';
import { DataIdConverterFactory } from 'src/app/core/services/mapper/data-id.converter';

export class RefContenant {
    static jsonMap = {
        idContenant: 'idContenant',
        codeContenant: 'codeContenant',
        libelleContenant: 'libelleContenant',
        volumeContenant: 'volumeContenant',
        refUnite: { key: 'idUniteContenant', converter: new (DataIdConverterFactory.build(RefUnite, 'refUnite'))() }
    };

    idContenant: number = undefined;
    codeContenant: string = undefined;
    libelleContenant: string = undefined;
    volumeContenant: number = undefined;
    refUnite: RefUnite = undefined;
}
